import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Website',
  subtitle: 'Development',
  tagline: 'High-Performance Websites',
  icon: '🌐',
  heroDesc: 'We build fast, secure, and scalable websites using modern technologies. From business websites to complex web applications, every site we deliver is optimized for speed, SEO, and conversions.',
  mainStat: '300+',
  mainStatLabel: 'Websites developed and launched successfully',
  subStats: [{ value: '<2s', label: 'Average Load Time' }, { value: '100%', label: 'Mobile Optimized' }],
  features: [
    { icon: '⚛️', title: 'React & Modern Stack', desc: 'Built with React, Next.js, and modern JavaScript for blazing-fast performance.' },
    { icon: '📝', title: 'WordPress Development', desc: 'Custom WordPress websites with powerful themes, plugins, and CMS capabilities.' },
    { icon: '🔒', title: 'Secure & Reliable', desc: 'SSL certificates, secure coding practices, and regular security updates included.' },
    { icon: '🔍', title: 'SEO-Optimized Build', desc: 'Technical SEO built into every page — schema markup, meta tags, and performance optimization.' },
    { icon: '📊', title: 'Analytics Integration', desc: 'Google Analytics, Search Console, and pixel tracking set up from day one.' },
    { icon: '🔧', title: 'Easy CMS Integration', desc: 'User-friendly content management so you can update your website without technical knowledge.' },
  ],
  benefits: [
    { title: 'Speed That Converts', desc: 'A 1-second improvement in load time increases conversions by up to 7%. Our sites are built for speed.' },
    { title: 'Search Engine Visibility', desc: 'Technical SEO implementation from the ground up gives your site the best chance to rank on Google.' },
    { title: 'Scalability', desc: 'Architecture built to grow with your business — add features, pages, and integrations as you scale.' },
    { title: 'Ongoing Reliability', desc: 'Regular maintenance, security updates, and performance monitoring keep your site running flawlessly.' },
  ],
  process: [
    { title: 'Requirements & Planning', desc: 'Detailed scoping of features, integrations, and technical requirements.' },
    { title: 'Design Approval', desc: 'Design mockups reviewed and approved before any development begins.' },
    { title: 'Development', desc: 'Clean, well-structured code built with performance and maintainability in mind.' },
    { title: 'Testing', desc: 'Cross-browser, cross-device, and performance testing before any launch.' },
    { title: 'Launch & Handover', desc: 'Smooth deployment with domain, hosting, SSL setup, and a full training session.' },
  ],
  whyChoose: [
    { icon: '👨‍💻', title: 'Expert Developers', desc: 'Experienced developers with expertise in React, WordPress, PHP, and modern web technologies.' },
    { icon: '📱', title: 'Mobile-First', desc: 'Every website is built mobile-first to deliver a perfect experience on all devices.' },
    { icon: '🚀', title: 'On-Time Delivery', desc: 'We set clear timelines and consistently deliver projects on or before the deadline.' },
    { icon: '🔧', title: 'Post-Launch Support', desc: 'Dedicated support period after launch to fix any issues and ensure smooth operation.' },
  ],
  reviews: [
    { name: 'Harish Patel', role: 'Manufacturer', text: 'Our new website loads in 1.2 seconds and we rank on page 1 of Google. Incredible work by DMS!' },
    { name: 'Sneha Kulkarni', role: 'Coaching Center', text: 'The website they built handles our online admissions seamlessly. Very professional and reliable.' },
    { name: 'Arun Sharma', role: 'Hotel Owner', text: 'Bookings increased by 80% after our new website launched. The team was fantastic throughout.' },
  ],
  faq: [
    { q: 'How long does website development take?', a: 'A standard business website takes 2–4 weeks. Complex sites with custom features may take 4–8 weeks.' },
    { q: 'Do you provide website maintenance after launch?', a: 'Yes! We offer monthly maintenance packages covering updates, backups, and security monitoring.' },
    { q: 'Can I update the website myself after it\'s built?', a: 'Absolutely. We build with user-friendly CMS systems and provide training so you can manage content easily.' },
  ],
};

export default function WebsiteDevelopment() {
  return <ServiceTemplate data={data} />;
}
